import { Route, Routes } from "react-router-dom";
import SettingsPage from "../../pages/shared-pages/settings/SettingsPage";


export default function SettingsNav() {
    return (
        <Routes>

            <Route path="/" element={<SettingsPage />} />
          

        </Routes>
    )
}
